import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { Banner } from "../../../../ui/organisms/banner"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { RightBar } from "../../../../ui/organisms/rightBar"
import { SuccessPopup } from "../../../../ui/organisms/successPopup"
import { GetAllOldMeasure, resetGetAllOldCodexMeasureStatus } from "../../../gestioneProvvedimenti/measures/edit/slice"
import { GetAllNewMeasure, NewMeasureTempDTO, OldMeasureTempDTO, resetGetAllNewMeasureStatus, setSavedNewMeasures, setSavedOldMeasures } from "../../../gestioneProvvedimenti/measures/slice"
import { GetRIDBYId, resetGetRidByIdResponse, resetRIDUpdateStatus, RIDUpdate } from "../slice"
import { EditRIDForms } from "./forms"
import { RightEditRID } from "./right"

export function EditRID() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const ridState = useAppSelector(state => state.rid)
    const sessionState = useAppSelector(state => state.session)
    const newMeasureState = useAppSelector(state => state.newMeasure)
    const oldCodexMeasure = useAppSelector(state => state.oldCodexMeasure)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (ridState.ridUpdateStatus === 'successfully') {
            setShowSuccess(true)
            dispatch(resetRIDUpdateStatus())
            dispatch(GetRIDBYId(ridState.ridIdToUpdate))
        }
    }, [ridState.ridUpdateStatus])

    useEffect(() => {
        if (ridState.ridStateUpdateStatus === 'successfully') {
            setShowSuccess(true)
        }
    }, [ridState.ridStateUpdateStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    useEffect(() => {
        dispatch(resetGetRidByIdResponse())

        dispatch(GetAllNewMeasure({
            itemsPerPage: 0,
            page: 0,
            customerId: sessionState.selected.customerId!
        }));
    }, [])

    useEffect(() => {
        if (newMeasureState.getAllNewMeasureStatus === 'successfully' &&
            newMeasureState.getAllNewMeasureResponse !== undefined
        ) {
            dispatch(resetGetAllNewMeasureStatus())
            const savedMeasure = newMeasureState.getAllNewMeasureResponse.data.map(nm => {
                return {
                    id: nm.id,
                    protocolInfo: nm.departureProtocolInfo,
                    ncCode: {
                        id: nm.newNonComplianceCodeDTO?.id,
                        code: nm.newNonComplianceCodeDTO?.nonComplianceCode
                    }
                } as NewMeasureTempDTO
            })
            dispatch(setSavedNewMeasures(savedMeasure))

            // DISPATCH GET ALL OLD CODEX
            dispatch(GetAllOldMeasure({
                itemsPerPage: 0,
                page: 0,
                customerId: sessionState.selected.customerId!,
                isCodexReleased: true
            }))
        }
    }, [newMeasureState.getAllNewMeasureStatus])

    useEffect(() => {
        if (oldCodexMeasure.getAllOldCodexMeasureStatus === 'successfully' &&
            oldCodexMeasure.getAllOldCodexMeasureResponse !== undefined
        ) {
            dispatch(resetGetAllOldCodexMeasureStatus())
            const savedOldMeasure = oldCodexMeasure.getAllOldCodexMeasureResponse.data.map(om => {
                return {
                    id: om.id,
                    protocolInfo: om.departureProtocolInfo,
                    code: om.nonCompliance?.nonComplianceCode
                } as OldMeasureTempDTO
            })
            dispatch(setSavedOldMeasures(savedOldMeasure))
        }
    }, [oldCodexMeasure.getAllOldCodexMeasureStatus])

    if (sessionState.selected.customerId) {
        return (
            <Layout
                menuItem={MenuItems.GESTIONE_CLIENTI}
                breadcrumbItems={['Gestione Clienti', 'Gestione RID']}
                noPaddingLat
                headerLabel="Modifica R.I.D."
                headerChildren={
                    <div className="flex items-center h-full w-full justify-end">
                        <ButtonComponent
                            size={"sm"}
                            iconPosition={"off"}
                            variant={"solid"}
                            label="Salva"
                            color={"orange"}
                            onClick={() => {
                                dispatch(RIDUpdate({ body: ridState.ridUpdateRequest, id: ridState.ridIdToUpdate }))
                            }}
                        />
                    </div>
                }
                headerIcon={
                    <ArrowLeftIcon onClick={() => navigate('/rid')} color={colors.brandPrimary[50]} size={0} />
                }
            >
                <div className="flex flex-col w-full h-full overflow-hidden">
                    {
                        showSuccess && (
                            <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                                <SuccessPopup
                                    active={showSuccess}
                                    message="Dati salvati correttamente."
                                    onClose={() => setShowSuccess(false)}
                                />
                            </div>
                        )
                    }
                    <div className="flex flex-1 overflow-hidden">
                        <div className="flex-[0.7] min-w-0 overflow-y-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] bg-neutral-50 border-r border-neutral-200 p-6">
                            {/* <div className="pb-5">
                            <ClientBanner
                                region={sessionState.selected.customerRegion!}
                                client={sessionState.selected.customerName!}
                                code={sessionState.selected.customerCode!}
                                activity={sessionState.selected.customerActivities ? `${sessionState.selected.customerActivities.map(act => optionsFormatter(act, attivita_bio))}` : undefined}
                                norm={optionsFormatter(sessionState.selected.customerNorm!, normativa)!}
                            />
                        </div> */}
                            <EditRIDForms />
                        </div>
                        <div className="flex-[0.3] min-w-0 overflow-y-auto bg-white">
                            <RightBar>
                                <RightEditRID />
                            </RightBar>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_CLIENTI}
            breadcrumbItems={['Gestione Clienti', 'Gestione RID']}
            noPaddingLat
            headerLabel={"Gestione R.I.D."}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}